// extracted by mini-css-extract-plugin
export default {"container":"DeletedView-module__container--xR7UJ","emptyWrapper":"DeletedView-module__emptyWrapper--tJew8","animatedBackground":"DeletedView-module__animatedBackground--kdxWG"};